import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { Observable, of } from 'rxjs'
import { environment } from 'src/environments/environment'

import { AuthService } from './modules/auth/_services/auth.service'

// locale register for date pipes
import { registerLocaleData } from '@angular/common'
import localeEn from '@angular/common/locales/en'
import localeFr from '@angular/common/locales/fr'
registerLocaleData(localeEn)
registerLocaleData(localeFr)

import { SocketIoConfig } from 'ngx-socket-io'

 // Ajout du module popup update obligatoire

const socketIoConfig: SocketIoConfig = {
  url: environment.socketUrl,
  options: {
    transports: ['websocket', 'polling'],
    // Add any additional options here
  },
}

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise<void>(resolve => {
      authService.getUserByToken().subscribe().add(resolve)
    })
  }
}

// Custom loader that returns empty translations
// Actual translations are loaded via TranslationService.loadTranslations() in app.component.ts
class CustomTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    return of({})
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader()
}


